import type { NodeMock, StatePreset } from "../mock-types";

export const selfSelectMock: NodeMock = {
  label: "Self Select",
  description: "Players pick which team to join",
  state: (players, teamCount) => {
    // Initialize empty teams (1-indexed keys)
    const teams: Record<number, string[]> = {};
    for (let t = 1; t <= teamCount; t++) teams[t] = [];

    // Put first player on team 1 so there's something to see
    const firstId = players[0]?.userId ?? "";
    teams[1] = [firstId];
    const teamAssignments: Record<string, number> = { [firstId]: 1 };

    return {
      teams,
      unassigned: players.slice(1).map((p) => p.userId),
      teamAssignments,
    };
  },
  config: {
    timeoutSeconds: 60,
    allowUneven: false,
    labels: {
      title: "Choose Your Team",
    },
  },
};

export const selfSelectPresets: StatePreset[] = [
  {
    label: "Empty Teams",
    build: ({ players, teamCount }) => {
      const teams: Record<number, string[]> = {};
      for (let t = 1; t <= teamCount; t++) teams[t] = [];
      return { state: { teams, unassigned: players.map((p) => p.userId), teamAssignments: {} } };
    },
  },
  {
    label: "Partially Filled",
    build: ({ players, teamCount }) => {
      const teams: Record<number, string[]> = {};
      for (let t = 1; t <= teamCount; t++) teams[t] = [];
      const teamAssignments: Record<string, number> = {};
      const half = Math.ceil(players.length / 2);
      players.slice(0, half).forEach((p, i) => {
        const t = (i % teamCount) + 1;
        teams[t].push(p.userId);
        teamAssignments[p.userId] = t;
      });
      return {
        state: { teams, unassigned: players.slice(half).map((p) => p.userId), teamAssignments },
      };
    },
  },
  {
    label: "All Assigned",
    build: ({ players, teamCount }) => {
      const teams: Record<number, string[]> = {};
      for (let t = 1; t <= teamCount; t++) teams[t] = [];
      const teamAssignments: Record<string, number> = {};
      players.forEach((p, i) => {
        const t = (i % teamCount) + 1;
        teams[t].push(p.userId);
        teamAssignments[p.userId] = t;
      });
      return { state: { teams, unassigned: [], teamAssignments } };
    },
  },
];
